import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import ArticleTab from '../../modules/article/ArticleTab';
import ArticleCategoryTab from '../../modules/articleCategory/ArticleCategoryTab';
import ArticleProductLineTab from '../../modules/articleProductLine/ArticleProductLineTab';



const Article = (props) => {

    const [activeTab, setActiveTab] = useState('ARTICLES');
    const [t] = useTranslation();

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('article.label.article')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('article.label.articles')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('article.label.article')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'ARTICLES'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('ARTICLES')
                                                    }
                                                >
                                                    {t('article.label.articles')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'CATEGORY'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('CATEGORY')
                                                    }
                                                >
                                                    {t('article.label.category')}
                                                </button>
                                            </li>                                          
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'PRODUCT_LINE'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('PRODUCT_LINE')
                                                    }
                                                >
                                                    {t('article.label.productLine')}
                                                </button>
                                            </li>             
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <ArticleTab
                                                isActive={activeTab === 'ARTICLES'}
                                               
                                            />                                                                                                                              
                                             <ArticleCategoryTab
                                                isActive={activeTab === 'CATEGORY'}
                                               
                                            />  
                                             <ArticleProductLineTab
                                                isActive={activeTab === 'PRODUCT_LINE'}
                                               
                                            />  
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default Article;